import e from "stream";
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
var t = {
    exports: {}
  },
  r = t.exports = function t() {
    var r = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== r ? r : {};
    function n() {
      var e = r.URL || r.webkitURL || null,
        n = t.toString();
      return u.BLOB_URL || (u.BLOB_URL = e.createObjectURL(new Blob(["(", n, ")();"], {
        type: "text/javascript"
      })));
    }
    var o = !r.document && !!r.postMessage,
      i = o && /blob:/i.test((r.location || {}).protocol),
      a = {},
      s = 0,
      u = {};
    if (u.parse = c, u.unparse = f, u.RECORD_SEP = String.fromCharCode(30), u.UNIT_SEP = String.fromCharCode(31), u.BYTE_ORDER_MARK = "\ufeff", u.BAD_DELIMITERS = ["\r", "\n", '"', u.BYTE_ORDER_MARK], u.WORKERS_SUPPORTED = !o && !!r.Worker, u.NODE_STREAM_INPUT = 1, u.LocalChunkSize = 10485760, u.RemoteChunkSize = 5242880, u.DefaultDelimiter = ",", u.Parser = b, u.ParserHandle = g, u.NetworkStreamer = d, u.FileStreamer = h, u.StringStreamer = v, u.ReadableStreamStreamer = y, "undefined" == typeof PAPA_BROWSER_CONTEXT && (u.DuplexStreamStreamer = m), r.jQuery) {
      var l = r.jQuery;
      l.fn.parse = function (e) {
        var t = e.config || {},
          n = [];
        return this.each(function (e) {
          if ("INPUT" !== l(this).prop("tagName").toUpperCase() || "file" !== l(this).attr("type").toLowerCase() || !r.FileReader || !this.files || 0 === this.files.length) return !0;
          for (var o = 0; o < this.files.length; o++) n.push({
            file: this.files[o],
            inputElem: this,
            instanceConfig: l.extend({}, t)
          });
        }), o(), this;
        function o() {
          if (0 !== n.length) {
            var t = n[0];
            if (j(e.before)) {
              var r = e.before(t.file, t.inputElem);
              if ("object" == typeof r) {
                if ("abort" === r.action) return void i("AbortError", t.file, t.inputElem, r.reason);
                if ("skip" === r.action) return void a();
                "object" == typeof r.config && (t.instanceConfig = l.extend(t.instanceConfig, r.config));
              } else if ("skip" === r) return void a();
            }
            var o = t.instanceConfig.complete;
            t.instanceConfig.complete = function (e) {
              j(o) && o(e, t.file, t.inputElem), a();
            }, u.parse(t.file, t.instanceConfig);
          } else j(e.complete) && e.complete();
        }
        function i(t, r, n, o) {
          j(e.error) && e.error({
            name: t
          }, r, n, o);
        }
        function a() {
          n.splice(0, 1), o();
        }
      };
    }
    function c(e, t) {
      var n = (t = t || {}).dynamicTyping || !1;
      if (j(n) && (t.dynamicTypingFunction = n, n = {}), t.dynamicTyping = n, t.transform = !!j(t.transform) && t.transform, t.worker && u.WORKERS_SUPPORTED) {
        var o = C();
        return o.userStep = t.step, o.userChunk = t.chunk, o.userComplete = t.complete, o.userError = t.error, t.step = j(t.step), t.chunk = j(t.chunk), t.complete = j(t.complete), t.error = j(t.error), delete t.worker, void o.postMessage({
          input: e,
          config: t,
          workerId: o.id
        });
      }
      var i = null;
      return e === u.NODE_STREAM_INPUT && "undefined" == typeof PAPA_BROWSER_CONTEXT ? (i = new m(t)).getStream() : ("string" == typeof e ? i = t.download ? new d(t) : new v(t) : !0 === e.readable && j(e.read) && j(e.on) ? i = new y(t) : (r.File && e instanceof File || e instanceof Object) && (i = new h(t)), i.stream(e));
    }
    function f(e, t) {
      var r = !1,
        n = !0,
        o = ",",
        i = "\r\n",
        a = '"',
        s = a + a,
        l = !1,
        c = null,
        f = !1;
      d();
      var p = new RegExp(_(a), "g");
      if ("string" == typeof e && (e = JSON.parse(e)), Array.isArray(e)) {
        if (!e.length || Array.isArray(e[0])) return h(null, e, l);
        if ("object" == typeof e[0]) return h(c || Object.keys(e[0]), e, l);
      } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [e.data])), h(e.fields || [], e.data || [], l);
      throw new Error("Unable to serialize unrecognized input");
      function d() {
        if ("object" == typeof t) {
          if ("string" != typeof t.delimiter || u.BAD_DELIMITERS.filter(function (e) {
            return -1 !== t.delimiter.indexOf(e);
          }).length || (o = t.delimiter), ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (r = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (l = t.skipEmptyLines), "string" == typeof t.newline && (i = t.newline), "string" == typeof t.quoteChar && (a = t.quoteChar), "boolean" == typeof t.header && (n = t.header), Array.isArray(t.columns)) {
            if (0 === t.columns.length) throw new Error("Option columns is empty");
            c = t.columns;
          }
          void 0 !== t.escapeChar && (s = t.escapeChar + a), "boolean" == typeof t.escapeFormulae && (f = t.escapeFormulae);
        }
      }
      function h(e, t, r) {
        var a = "";
        "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
        var s = Array.isArray(e) && e.length > 0,
          u = !Array.isArray(t[0]);
        if (s && n) {
          for (var l = 0; l < e.length; l++) l > 0 && (a += o), a += v(e[l], l);
          t.length > 0 && (a += i);
        }
        for (var c = 0; c < t.length; c++) {
          var f = s ? e.length : t[c].length,
            p = !1,
            d = s ? 0 === Object.keys(t[c]).length : 0 === t[c].length;
          if (r && !s && (p = "greedy" === r ? "" === t[c].join("").trim() : 1 === t[c].length && 0 === t[c][0].length), "greedy" === r && s) {
            for (var h = [], y = 0; y < f; y++) {
              var m = u ? e[y] : y;
              h.push(t[c][m]);
            }
            p = "" === h.join("").trim();
          }
          if (!p) {
            for (var g = 0; g < f; g++) {
              g > 0 && !d && (a += o);
              var _ = s && u ? e[g] : g;
              a += v(t[c][_], g);
            }
            c < t.length - 1 && (!r || f > 0 && !d) && (a += i);
          }
        }
        return a;
      }
      function v(e, t) {
        if (null == e) return "";
        if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
        !0 === f && "string" == typeof e && null !== e.match(/^[=+\-@].*$/) && (e = "'" + e);
        var n = e.toString().replace(p, s);
        return "boolean" == typeof r && r || "function" == typeof r && r(e, t) || Array.isArray(r) && r[t] || y(n, u.BAD_DELIMITERS) || n.indexOf(o) > -1 || " " === n.charAt(0) || " " === n.charAt(n.length - 1) ? a + n + a : n;
      }
      function y(e, t) {
        for (var r = 0; r < t.length; r++) if (e.indexOf(t[r]) > -1) return !0;
        return !1;
      }
    }
    function p(e) {
      function t(e) {
        var t = O(e);
        t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null), this._handle = new g(t), this._handle.streamer = this, this._config = t;
      }
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
        data: [],
        errors: [],
        meta: {}
      }, t.call(this, e), this.parseChunk = function (e, t) {
        if (this.isFirstChunk && j(this._config.beforeFirstChunk)) {
          var n = this._config.beforeFirstChunk(e);
          void 0 !== n && (e = n);
        }
        this.isFirstChunk = !1, this._halted = !1;
        var o = this._partialLine + e;
        this._partialLine = "";
        var a = this._handle.parse(o, this._baseIndex, !this._finished);
        if (!this._handle.paused() && !this._handle.aborted()) {
          var s = a.meta.cursor;
          this._finished || (this._partialLine = o.substring(s - this._baseIndex), this._baseIndex = s), a && a.data && (this._rowCount += a.data.length);
          var l = this._finished || this._config.preview && this._rowCount >= this._config.preview;
          if (i) r.postMessage({
            results: a,
            workerId: u.WORKER_ID,
            finished: l
          });else if (j(this._config.chunk) && !t) {
            if (this._config.chunk(a, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
            a = void 0, this._completeResults = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(a.data), this._completeResults.errors = this._completeResults.errors.concat(a.errors), this._completeResults.meta = a.meta), this._completed || !l || !j(this._config.complete) || a && a.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), l || a && a.meta.paused || this._nextChunk(), a;
        }
        this._halted = !0;
      }, this._sendError = function (e) {
        j(this._config.error) ? this._config.error(e) : i && this._config.error && r.postMessage({
          workerId: u.WORKER_ID,
          error: e,
          finished: !1
        });
      };
    }
    function d(e) {
      var t;
      function r(e) {
        var t = e.getResponseHeader("Content-Range");
        return null === t ? -1 : parseInt(t.substring(t.lastIndexOf("/") + 1));
      }
      (e = e || {}).chunkSize || (e.chunkSize = u.RemoteChunkSize), p.call(this, e), this._nextChunk = o ? function () {
        this._readChunk(), this._chunkLoaded();
      } : function () {
        this._readChunk();
      }, this.stream = function (e) {
        this._input = e, this._nextChunk();
      }, this._readChunk = function () {
        if (this._finished) this._chunkLoaded();else {
          if (t = new XMLHttpRequest(), this._config.withCredentials && (t.withCredentials = this._config.withCredentials), o || (t.onload = S(this._chunkLoaded, this), t.onerror = S(this._chunkError, this)), t.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !o), this._config.downloadRequestHeaders) {
            var e = this._config.downloadRequestHeaders;
            for (var r in e) t.setRequestHeader(r, e[r]);
          }
          if (this._config.chunkSize) {
            var n = this._start + this._config.chunkSize - 1;
            t.setRequestHeader("Range", "bytes=" + this._start + "-" + n);
          }
          try {
            t.send(this._config.downloadRequestBody);
          } catch (e) {
            this._chunkError(e.message);
          }
          o && 0 === t.status && this._chunkError();
        }
      }, this._chunkLoaded = function () {
        4 === t.readyState && (t.status < 200 || t.status >= 400 ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : t.responseText.length, this._finished = !this._config.chunkSize || this._start >= r(t), this.parseChunk(t.responseText)));
      }, this._chunkError = function (e) {
        var r = t.statusText || e;
        this._sendError(new Error(r));
      };
    }
    function h(e) {
      var t, r;
      (e = e || {}).chunkSize || (e.chunkSize = u.LocalChunkSize), p.call(this, e);
      var n = "undefined" != typeof FileReader;
      this.stream = function (e) {
        this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((t = new FileReader()).onload = S(this._chunkLoaded, this), t.onerror = S(this._chunkError, this)) : t = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function () {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function () {
        var e = this._input;
        if (this._config.chunkSize) {
          var o = Math.min(this._start + this._config.chunkSize, this._input.size);
          e = r.call(e, this._start, o);
        }
        var i = t.readAsText(e, this._config.encoding);
        n || this._chunkLoaded({
          target: {
            result: i
          }
        });
      }, this._chunkLoaded = function (e) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
      }, this._chunkError = function () {
        this._sendError(t.error);
      };
    }
    function v(e) {
      var t;
      e = e || {}, p.call(this, e), this.stream = function (e) {
        return t = e, this._nextChunk();
      }, this._nextChunk = function () {
        if (!this._finished) {
          var e,
            r = this._config.chunkSize;
          return r ? (e = t.substring(0, r), t = t.substring(r)) : (e = t, t = ""), this._finished = !t, this.parseChunk(e);
        }
      };
    }
    function y(e) {
      e = e || {}, p.call(this, e);
      var t = [],
        r = !0,
        n = !1;
      this.pause = function () {
        p.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function () {
        p.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function (e) {
        this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function () {
        n && 1 === t.length && (this._finished = !0);
      }, this._nextChunk = function () {
        this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
      }, this._streamData = S(function (e) {
        try {
          t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
        } catch (e) {
          this._streamError(e);
        }
      }, this), this._streamError = S(function (e) {
        this._streamCleanUp(), this._sendError(e);
      }, this), this._streamEnd = S(function () {
        this._streamCleanUp(), n = !0, this._streamData("");
      }, this), this._streamCleanUp = S(function () {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function m(t) {
      var r = e.Duplex,
        n = O(t),
        o = !0,
        i = !1,
        a = [],
        s = null;
      this._onCsvData = function (e) {
        var t = e.data;
        s.push(t) || this._handle.paused() || this._handle.pause();
      }, this._onCsvComplete = function () {
        s.push(null);
      }, n.step = S(this._onCsvData, this), n.complete = S(this._onCsvComplete, this), p.call(this, n), this._nextChunk = function () {
        i && 1 === a.length && (this._finished = !0), a.length ? a.shift()() : o = !0;
      }, this._addToParseQueue = function (e, t) {
        a.push(S(function () {
          if (this.parseChunk("string" == typeof e ? e : e.toString(n.encoding)), j(t)) return t();
        }, this)), o && (o = !1, this._nextChunk());
      }, this._onRead = function () {
        this._handle.paused() && this._handle.resume();
      }, this._onWrite = function (e, t, r) {
        this._addToParseQueue(e, r);
      }, this._onWriteComplete = function () {
        i = !0, this._addToParseQueue("");
      }, this.getStream = function () {
        return s;
      }, (s = new r({
        readableObjectMode: !0,
        decodeStrings: !1,
        read: S(this._onRead, this),
        write: S(this._onWrite, this)
      })).once("finish", S(this._onWriteComplete, this));
    }
    function g(e) {
      var t,
        r,
        n,
        o = Math.pow(2, 53),
        i = -o,
        a = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/,
        s = /^(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))$/,
        l = this,
        c = 0,
        f = 0,
        p = !1,
        d = !1,
        h = [],
        v = {
          data: [],
          errors: [],
          meta: {}
        };
      if (j(e.step)) {
        var y = e.step;
        e.step = function (t) {
          if (v = t, R()) C();else {
            if (C(), 0 === v.data.length) return;
            c += t.data.length, e.preview && c > e.preview ? r.abort() : (v.data = v.data[0], y(v, l));
          }
        };
      }
      function m(t) {
        return "greedy" === e.skipEmptyLines ? "" === t.join("").trim() : 1 === t.length && 0 === t[0].length;
      }
      function g(e) {
        if (a.test(e)) {
          var t = parseFloat(e);
          if (t > i && t < o) return !0;
        }
        return !1;
      }
      function C() {
        if (v && n && (A("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + u.DefaultDelimiter + "'"), n = !1), e.skipEmptyLines) for (var t = 0; t < v.data.length; t++) m(v.data[t]) && v.data.splice(t--, 1);
        return R() && w(), S();
      }
      function R() {
        return e.header && 0 === h.length;
      }
      function w() {
        if (v) if (Array.isArray(v.data[0])) {
          for (var t = 0; R() && t < v.data.length; t++) v.data[t].forEach(r);
          v.data.splice(0, 1);
        } else v.data.forEach(r);
        function r(t, r) {
          j(e.transformHeader) && (t = e.transformHeader(t, r)), h.push(t);
        }
      }
      function k(t) {
        return e.dynamicTypingFunction && void 0 === e.dynamicTyping[t] && (e.dynamicTyping[t] = e.dynamicTypingFunction(t)), !0 === (e.dynamicTyping[t] || e.dynamicTyping);
      }
      function E(e, t) {
        return k(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (g(t) ? parseFloat(t) : s.test(t) ? new Date(t) : "" === t ? null : t) : t;
      }
      function S() {
        if (!v || !e.header && !e.dynamicTyping && !e.transform) return v;
        function t(t, r) {
          var n,
            o = e.header ? {} : [];
          for (n = 0; n < t.length; n++) {
            var i = n,
              a = t[n];
            e.header && (i = n >= h.length ? "__parsed_extra" : h[n]), e.transform && (a = e.transform(a, i)), a = E(i, a), "__parsed_extra" === i ? (o[i] = o[i] || [], o[i].push(a)) : o[i] = a;
          }
          return e.header && (n > h.length ? A("FieldMismatch", "TooManyFields", "Too many fields: expected " + h.length + " fields but parsed " + n, f + r) : n < h.length && A("FieldMismatch", "TooFewFields", "Too few fields: expected " + h.length + " fields but parsed " + n, f + r)), o;
        }
        var r = 1;
        return !v.data.length || Array.isArray(v.data[0]) ? (v.data = v.data.map(t), r = v.data.length) : v.data = t(v.data, 0), e.header && v.meta && (v.meta.fields = h), f += r, v;
      }
      function P(t, r, n, o, i) {
        var a, s, l, c;
        i = i || [",", "\t", "|", ";", u.RECORD_SEP, u.UNIT_SEP];
        for (var f = 0; f < i.length; f++) {
          var p = i[f],
            d = 0,
            h = 0,
            v = 0;
          l = void 0;
          for (var y = new b({
              comments: o,
              delimiter: p,
              newline: r,
              preview: 10
            }).parse(t), g = 0; g < y.data.length; g++) if (n && m(y.data[g])) v++;else {
            var _ = y.data[g].length;
            h += _, void 0 !== l ? _ > 0 && (d += Math.abs(_ - l), l = _) : l = _;
          }
          y.data.length > 0 && (h /= y.data.length - v), (void 0 === s || d <= s) && (void 0 === c || h > c) && h > 1.99 && (s = d, a = p, c = h);
        }
        return e.delimiter = a, {
          successful: !!a,
          bestDelimiter: a
        };
      }
      function x(e, t) {
        e = e.substring(0, 1048576);
        var r = new RegExp(_(t) + "([^]*?)" + _(t), "gm"),
          n = (e = e.replace(r, "")).split("\r"),
          o = e.split("\n"),
          i = o.length > 1 && o[0].length < n[0].length;
        if (1 === n.length || i) return "\n";
        for (var a = 0, s = 0; s < n.length; s++) "\n" === n[s][0] && a++;
        return a >= n.length / 2 ? "\r\n" : "\r";
      }
      function A(e, t, r, n) {
        var o = {
          type: e,
          code: t,
          message: r
        };
        void 0 !== n && (o.row = n), v.errors.push(o);
      }
      this.parse = function (o, i, a) {
        var s = e.quoteChar || '"';
        if (e.newline || (e.newline = x(o, s)), n = !1, e.delimiter) j(e.delimiter) && (e.delimiter = e.delimiter(o), v.meta.delimiter = e.delimiter);else {
          var l = P(o, e.newline, e.skipEmptyLines, e.comments, e.delimitersToGuess);
          l.successful ? e.delimiter = l.bestDelimiter : (n = !0, e.delimiter = u.DefaultDelimiter), v.meta.delimiter = e.delimiter;
        }
        var c = O(e);
        return e.preview && e.header && c.preview++, t = o, r = new b(c), v = r.parse(t, i, a), C(), p ? {
          meta: {
            paused: !0
          }
        } : v || {
          meta: {
            paused: !1
          }
        };
      }, this.paused = function () {
        return p;
      }, this.pause = function () {
        p = !0, r.abort(), t = j(e.chunk) ? "" : t.substring(r.getCharIndex());
      }, this.resume = function () {
        l.streamer._halted ? (p = !1, l.streamer.parseChunk(t, !0)) : setTimeout(l.resume, 3);
      }, this.aborted = function () {
        return d;
      }, this.abort = function () {
        d = !0, r.abort(), v.meta.aborted = !0, j(e.complete) && e.complete(v), t = "";
      };
    }
    function _(e) {
      return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function b(e) {
      var t,
        r = (e = e || {}).delimiter,
        n = e.newline,
        o = e.comments,
        i = e.step,
        a = e.preview,
        s = e.fastMode,
        l = t = void 0 === e.quoteChar ? '"' : e.quoteChar;
      if (void 0 !== e.escapeChar && (l = e.escapeChar), ("string" != typeof r || u.BAD_DELIMITERS.indexOf(r) > -1) && (r = ","), o === r) throw new Error("Comment character same as delimiter");
      !0 === o ? o = "#" : ("string" != typeof o || u.BAD_DELIMITERS.indexOf(o) > -1) && (o = !1), "\n" !== n && "\r" !== n && "\r\n" !== n && (n = "\n");
      var c = 0,
        f = !1;
      this.parse = function (e, u, p) {
        if ("string" != typeof e) throw new Error("Input must be a string");
        var d = e.length,
          h = r.length,
          v = n.length,
          y = o.length,
          m = j(i);
        c = 0;
        var g = [],
          b = [],
          C = [],
          R = 0;
        if (!e) return B();
        if (s || !1 !== s && -1 === e.indexOf(t)) {
          for (var w = e.split(n), k = 0; k < w.length; k++) {
            if (C = w[k], c += C.length, k !== w.length - 1) c += n.length;else if (p) return B();
            if (!o || C.substring(0, y) !== o) {
              if (m) {
                if (g = [], I(C.split(r)), L(), f) return B();
              } else I(C.split(r));
              if (a && k >= a) return g = g.slice(0, a), B(!0);
            }
          }
          return B();
        }
        for (var E = e.indexOf(r, c), O = e.indexOf(n, c), S = new RegExp(_(l) + _(t), "g"), P = e.indexOf(t, c);;) if (e[c] !== t) {
          if (o && 0 === C.length && e.substring(c, c + y) === o) {
            if (-1 === O) return B();
            c = O + v, O = e.indexOf(n, c), E = e.indexOf(r, c);
          } else if (-1 !== E && (E < O || -1 === O)) C.push(e.substring(c, E)), c = E + h, E = e.indexOf(r, c);else {
            if (-1 === O) break;
            if (C.push(e.substring(c, O)), T(O + v), m && (L(), f)) return B();
            if (a && g.length >= a) return B(!0);
          }
        } else for (P = c, c++;;) {
          if (-1 === (P = e.indexOf(t, P + 1))) return p || b.push({
            type: "Quotes",
            code: "MissingQuotes",
            message: "Quoted field unterminated",
            row: g.length,
            index: c
          }), D();
          if (P === d - 1) return D(e.substring(c, P).replace(S, t));
          if (t !== l || e[P + 1] !== l) {
            if (t === l || 0 === P || e[P - 1] !== l) {
              -1 !== E && E < P + 1 && (E = e.indexOf(r, P + 1)), -1 !== O && O < P + 1 && (O = e.indexOf(n, P + 1));
              var x = F(-1 === O ? E : Math.min(E, O));
              if (e[P + 1 + x] === r) {
                C.push(e.substring(c, P).replace(S, t)), c = P + 1 + x + h, e[P + 1 + x + h] !== t && (P = e.indexOf(t, c)), E = e.indexOf(r, c), O = e.indexOf(n, c);
                break;
              }
              var A = F(O);
              if (e.substring(P + 1 + A, P + 1 + A + v) === n) {
                if (C.push(e.substring(c, P).replace(S, t)), T(P + 1 + A + v), E = e.indexOf(r, c), P = e.indexOf(t, c), m && (L(), f)) return B();
                if (a && g.length >= a) return B(!0);
                break;
              }
              b.push({
                type: "Quotes",
                code: "InvalidQuotes",
                message: "Trailing quote on quoted field is malformed",
                row: g.length,
                index: c
              }), P++;
            }
          } else P++;
        }
        return D();
        function I(e) {
          g.push(e), R = c;
        }
        function F(t) {
          var r = 0;
          if (-1 !== t) {
            var n = e.substring(P + 1, t);
            n && "" === n.trim() && (r = n.length);
          }
          return r;
        }
        function D(t) {
          return p || (void 0 === t && (t = e.substring(c)), C.push(t), c = d, I(C), m && L()), B();
        }
        function T(t) {
          c = t, I(C), C = [], O = e.indexOf(n, c);
        }
        function B(e) {
          return {
            data: g,
            errors: b,
            meta: {
              delimiter: r,
              linebreak: n,
              aborted: f,
              truncated: !!e,
              cursor: R + (u || 0)
            }
          };
        }
        function L() {
          i(B()), g = [], b = [];
        }
      }, this.abort = function () {
        f = !0;
      }, this.getCharIndex = function () {
        return c;
      };
    }
    function C() {
      if (!u.WORKERS_SUPPORTED) return !1;
      var e = n(),
        t = new r.Worker(e);
      return t.onmessage = R, t.id = s++, a[t.id] = t, t;
    }
    function R(e) {
      var t = e.data,
        r = a[t.workerId],
        n = !1;
      if (t.error) r.userError(t.error, t.file);else if (t.results && t.results.data) {
        var o = {
          abort: function () {
            n = !0, w(t.workerId, {
              data: [],
              errors: [],
              meta: {
                aborted: !0
              }
            });
          },
          pause: k,
          resume: k
        };
        if (j(r.userStep)) {
          for (var i = 0; i < t.results.data.length && (r.userStep({
            data: t.results.data[i],
            errors: t.results.errors,
            meta: t.results.meta
          }, o), !n); i++);
          delete t.results;
        } else j(r.userChunk) && (r.userChunk(t.results, o, t.file), delete t.results);
      }
      t.finished && !n && w(t.workerId, t.results);
    }
    function w(e, t) {
      var r = a[e];
      j(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function k() {
      throw new Error("Not implemented.");
    }
    function E(e) {
      var t = e.data;
      if (void 0 === u.WORKER_ID && t && (u.WORKER_ID = t.workerId), "string" == typeof t.input) r.postMessage({
        workerId: u.WORKER_ID,
        results: u.parse(t.input, t.config),
        finished: !0
      });else if (r.File && t.input instanceof File || t.input instanceof Object) {
        var n = u.parse(t.input, t.config);
        n && r.postMessage({
          workerId: u.WORKER_ID,
          results: n,
          finished: !0
        });
      }
    }
    function O(e) {
      if ("object" != typeof e || null === e) return e;
      var t = Array.isArray(e) ? [] : {};
      for (var r in e) t[r] = O(e[r]);
      return t;
    }
    function S(e, t) {
      return function () {
        e.apply(t, arguments);
      };
    }
    function j(e) {
      return "function" == typeof e;
    }
    return i && (r.onmessage = E), d.prototype = Object.create(p.prototype), d.prototype.constructor = d, h.prototype = Object.create(p.prototype), h.prototype.constructor = h, v.prototype = Object.create(v.prototype), v.prototype.constructor = v, y.prototype = Object.create(p.prototype), y.prototype.constructor = y, "undefined" == typeof PAPA_BROWSER_CONTEXT && (m.prototype = Object.create(p.prototype), m.prototype.constructor = m), u;
  }(),
  n = function (e, t) {
    return (n = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    })(e, t);
  };
function o(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  function r() {
    this.constructor = e;
  }
  n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
}
function i(e, t) {
  for (var r = 0, n = t.length, o = e.length; r < n; r++, o++) e[o] = t[r];
  return e;
}
var a = {
    exports: {}
  },
  s = {},
  u = Object.getOwnPropertySymbols,
  l = Object.prototype.hasOwnProperty,
  c = Object.prototype.propertyIsEnumerable;
function f(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
var p = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var n = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        n[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var r, n, o = f(e), i = 1; i < arguments.length; i++) {
      for (var a in r = Object(arguments[i])) l.call(r, a) && (o[a] = r[a]);
      if (u) {
        n = u(r);
        for (var s = 0; s < n.length; s++) c.call(r, n[s]) && (o[n[s]] = r[n[s]]);
      }
    }
    return o;
  },
  d = p,
  h = 60103,
  v = 60106;
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
s.Fragment = 60107, s.StrictMode = 60108, s.Profiler = 60114;
var y = 60109,
  m = 60110,
  g = 60112;
s.Suspense = 60113;
var _ = 60115,
  b = 60116;
if ("function" == typeof Symbol && Symbol.for) {
  var C = Symbol.for;
  h = C("react.element"), v = C("react.portal"), s.Fragment = C("react.fragment"), s.StrictMode = C("react.strict_mode"), s.Profiler = C("react.profiler"), y = C("react.provider"), m = C("react.context"), g = C("react.forward_ref"), s.Suspense = C("react.suspense"), _ = C("react.memo"), b = C("react.lazy");
}
var R = "function" == typeof Symbol && Symbol.iterator;
function w(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 1; r < arguments.length; r++) t += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var k = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {}
  },
  E = {};
function O(e, t, r) {
  this.props = e, this.context = t, this.refs = E, this.updater = r || k;
}
function S() {}
function j(e, t, r) {
  this.props = e, this.context = t, this.refs = E, this.updater = r || k;
}
O.prototype.isReactComponent = {}, O.prototype.setState = function (e, t) {
  if ("object" != typeof e && "function" != typeof e && null != e) throw Error(w(85));
  this.updater.enqueueSetState(this, e, t, "setState");
}, O.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
}, S.prototype = O.prototype;
var P = j.prototype = new S();
P.constructor = j, d(P, O.prototype), P.isPureReactComponent = !0;
var x = {
    current: null
  },
  A = Object.prototype.hasOwnProperty,
  I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function F(e, t, r) {
  var n,
    o = {},
    i = null,
    a = null;
  if (null != t) for (n in void 0 !== t.ref && (a = t.ref), void 0 !== t.key && (i = "" + t.key), t) A.call(t, n) && !I.hasOwnProperty(n) && (o[n] = t[n]);
  var s = arguments.length - 2;
  if (1 === s) o.children = r;else if (1 < s) {
    for (var u = Array(s), l = 0; l < s; l++) u[l] = arguments[l + 2];
    o.children = u;
  }
  if (e && e.defaultProps) for (n in s = e.defaultProps) void 0 === o[n] && (o[n] = s[n]);
  return {
    $$typeof: h,
    type: e,
    key: i,
    ref: a,
    props: o,
    _owner: x.current
  };
}
function D(e) {
  return "object" == typeof e && null !== e && e.$$typeof === h;
}
var T = /\/+/g;
function B(e, t) {
  return "object" == typeof e && null !== e && null != e.key ? function (e) {
    var t = {
      "=": "=0",
      ":": "=2"
    };
    return "$" + e.replace(/[=:]/g, function (e) {
      return t[e];
    });
  }("" + e.key) : t.toString(36);
}
function L(e, t, r, n, o) {
  var i = typeof e;
  "undefined" !== i && "boolean" !== i || (e = null);
  var a = !1;
  if (null === e) a = !0;else switch (i) {
    case "string":
    case "number":
      a = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case h:
        case v:
          a = !0;
      }
  }
  if (a) return o = o(a = e), e = "" === n ? "." + B(a, 0) : n, Array.isArray(o) ? (r = "", null != e && (r = e.replace(T, "$&/") + "/"), L(o, t, r, "", function (e) {
    return e;
  })) : null != o && (D(o) && (o = function (e, t) {
    return {
      $$typeof: h,
      type: e.type,
      key: t,
      ref: e.ref,
      props: e.props,
      _owner: e._owner
    };
  }(o, r + (!o.key || a && a.key === o.key ? "" : ("" + o.key).replace(T, "$&/") + "/") + e)), t.push(o)), 1;
  if (a = 0, n = "" === n ? "." : n + ":", Array.isArray(e)) for (var s = 0; s < e.length; s++) {
    var u = n + B(i = e[s], s);
    a += L(i, t, r, u, o);
  } else if ("function" == typeof (u = function (e) {
    return null === e || "object" != typeof e ? null : "function" == typeof (e = R && e[R] || e["@@iterator"]) ? e : null;
  }(e))) for (e = u.call(e), s = 0; !(i = e.next()).done;) a += L(i = i.value, t, r, u = n + B(i, s++), o);else if ("object" === i) throw t = "" + e, Error(w(31, "[object Object]" === t ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
  return a;
}
function $(e, t, r) {
  if (null == e) return e;
  var n = [],
    o = 0;
  return L(e, n, "", "", function (e) {
    return t.call(r, e, o++);
  }), n;
}
function N(e) {
  if (-1 === e._status) {
    var t = e._result;
    t = t(), e._status = 0, e._result = t, t.then(function (t) {
      0 === e._status && (t = t.default, e._status = 1, e._result = t);
    }, function (t) {
      0 === e._status && (e._status = 2, e._result = t);
    });
  }
  if (1 === e._status) return e._result;
  throw e._result;
}
var M = {
  current: null
};
function z() {
  var e = M.current;
  if (null === e) throw Error(w(321));
  return e;
}
var U = {
  ReactCurrentDispatcher: M,
  ReactCurrentBatchConfig: {
    transition: 0
  },
  ReactCurrentOwner: x,
  IsSomeRendererActing: {
    current: !1
  },
  assign: d
};
s.Children = {
  map: $,
  forEach: function (e, t, r) {
    $(e, function () {
      t.apply(this, arguments);
    }, r);
  },
  count: function (e) {
    var t = 0;
    return $(e, function () {
      t++;
    }), t;
  },
  toArray: function (e) {
    return $(e, function (e) {
      return e;
    }) || [];
  },
  only: function (e) {
    if (!D(e)) throw Error(w(143));
    return e;
  }
}, s.Component = O, s.PureComponent = j, s.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = U, s.cloneElement = function (e, t, r) {
  if (null == e) throw Error(w(267, e));
  var n = d({}, e.props),
    o = e.key,
    i = e.ref,
    a = e._owner;
  if (null != t) {
    if (void 0 !== t.ref && (i = t.ref, a = x.current), void 0 !== t.key && (o = "" + t.key), e.type && e.type.defaultProps) var s = e.type.defaultProps;
    for (u in t) A.call(t, u) && !I.hasOwnProperty(u) && (n[u] = void 0 === t[u] && void 0 !== s ? s[u] : t[u]);
  }
  var u = arguments.length - 2;
  if (1 === u) n.children = r;else if (1 < u) {
    s = Array(u);
    for (var l = 0; l < u; l++) s[l] = arguments[l + 2];
    n.children = s;
  }
  return {
    $$typeof: h,
    type: e.type,
    key: o,
    ref: i,
    props: n,
    _owner: a
  };
}, s.createContext = function (e, t) {
  return void 0 === t && (t = null), (e = {
    $$typeof: m,
    _calculateChangedBits: t,
    _currentValue: e,
    _currentValue2: e,
    _threadCount: 0,
    Provider: null,
    Consumer: null
  }).Provider = {
    $$typeof: y,
    _context: e
  }, e.Consumer = e;
}, s.createElement = F, s.createFactory = function (e) {
  var t = F.bind(null, e);
  return t.type = e, t;
}, s.createRef = function () {
  return {
    current: null
  };
}, s.forwardRef = function (e) {
  return {
    $$typeof: g,
    render: e
  };
}, s.isValidElement = D, s.lazy = function (e) {
  return {
    $$typeof: b,
    _payload: {
      _status: -1,
      _result: e
    },
    _init: N
  };
}, s.memo = function (e, t) {
  return {
    $$typeof: _,
    type: e,
    compare: void 0 === t ? null : t
  };
}, s.useCallback = function (e, t) {
  return z().useCallback(e, t);
}, s.useContext = function (e, t) {
  return z().useContext(e, t);
}, s.useDebugValue = function () {}, s.useEffect = function (e, t) {
  return z().useEffect(e, t);
}, s.useImperativeHandle = function (e, t, r) {
  return z().useImperativeHandle(e, t, r);
}, s.useLayoutEffect = function (e, t) {
  return z().useLayoutEffect(e, t);
}, s.useMemo = function (e, t) {
  return z().useMemo(e, t);
}, s.useReducer = function (e, t, r) {
  return z().useReducer(e, t, r);
}, s.useRef = function (e) {
  return z().useRef(e);
}, s.useState = function (e) {
  return z().useState(e);
}, s.version = "17.0.2";
var q,
  W = {};
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
q = W, "production" !== process.env.NODE_ENV && function () {
  var e = p,
    t = 60103,
    r = 60106;
  q.Fragment = 60107, q.StrictMode = 60108, q.Profiler = 60114;
  var n = 60109,
    o = 60110,
    i = 60112;
  q.Suspense = 60113;
  var a = 60120,
    s = 60115,
    u = 60116,
    l = 60121,
    c = 60122,
    f = 60117,
    d = 60129,
    h = 60131;
  if ("function" == typeof Symbol && Symbol.for) {
    var v = Symbol.for;
    t = v("react.element"), r = v("react.portal"), q.Fragment = v("react.fragment"), q.StrictMode = v("react.strict_mode"), q.Profiler = v("react.profiler"), n = v("react.provider"), o = v("react.context"), i = v("react.forward_ref"), q.Suspense = v("react.suspense"), a = v("react.suspense_list"), s = v("react.memo"), u = v("react.lazy"), l = v("react.block"), c = v("react.server.block"), f = v("react.fundamental"), v("react.scope"), v("react.opaque.id"), d = v("react.debug_trace_mode"), v("react.offscreen"), h = v("react.legacy_hidden");
  }
  var y = "function" == typeof Symbol && Symbol.iterator;
  function m(e) {
    if (null === e || "object" != typeof e) return null;
    var t = y && e[y] || e["@@iterator"];
    return "function" == typeof t ? t : null;
  }
  var g = {
      current: null
    },
    _ = {
      current: null
    },
    b = {},
    C = null;
  function R(e) {
    C = e;
  }
  b.setExtraStackFrame = function (e) {
    C = e;
  }, b.getCurrentStack = null, b.getStackAddendum = function () {
    var e = "";
    C && (e += C);
    var t = b.getCurrentStack;
    return t && (e += t() || ""), e;
  };
  var w = {
    ReactCurrentDispatcher: g,
    ReactCurrentBatchConfig: {
      transition: 0
    },
    ReactCurrentOwner: _,
    IsSomeRendererActing: {
      current: !1
    },
    assign: e
  };
  function k(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
    O("warn", e, r);
  }
  function E(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
    O("error", e, r);
  }
  function O(e, t, r) {
    var n = w.ReactDebugCurrentFrame.getStackAddendum();
    "" !== n && (t += "%s", r = r.concat([n]));
    var o = r.map(function (e) {
      return "" + e;
    });
    o.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, o);
  }
  w.ReactDebugCurrentFrame = b;
  var S = {};
  function j(e, t) {
    var r = e.constructor,
      n = r && (r.displayName || r.name) || "ReactClass",
      o = n + "." + t;
    S[o] || (E("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, n), S[o] = !0);
  }
  var P = {
      isMounted: function (e) {
        return !1;
      },
      enqueueForceUpdate: function (e, t, r) {
        j(e, "forceUpdate");
      },
      enqueueReplaceState: function (e, t, r, n) {
        j(e, "replaceState");
      },
      enqueueSetState: function (e, t, r, n) {
        j(e, "setState");
      }
    },
    x = {};
  function A(e, t, r) {
    this.props = e, this.context = t, this.refs = x, this.updater = r || P;
  }
  Object.freeze(x), A.prototype.isReactComponent = {}, A.prototype.setState = function (e, t) {
    if ("object" != typeof e && "function" != typeof e && null != e) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, e, t, "setState");
  }, A.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  };
  var I = {
      isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
      replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
    },
    F = function (e, t) {
      Object.defineProperty(A.prototype, e, {
        get: function () {
          k("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
        }
      });
    };
  for (var D in I) I.hasOwnProperty(D) && F(D, I[D]);
  function T() {}
  function B(e, t, r) {
    this.props = e, this.context = t, this.refs = x, this.updater = r || P;
  }
  T.prototype = A.prototype;
  var L = B.prototype = new T();
  function $(e) {
    return e.displayName || "Context";
  }
  function N(e) {
    if (null == e) return null;
    if ("number" == typeof e.tag && E("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), "function" == typeof e) return e.displayName || e.name || null;
    if ("string" == typeof e) return e;
    switch (e) {
      case q.Fragment:
        return "Fragment";
      case r:
        return "Portal";
      case q.Profiler:
        return "Profiler";
      case q.StrictMode:
        return "StrictMode";
      case q.Suspense:
        return "Suspense";
      case a:
        return "SuspenseList";
    }
    if ("object" == typeof e) switch (e.$$typeof) {
      case o:
        return $(e) + ".Consumer";
      case n:
        return $(e._context) + ".Provider";
      case i:
        return p = e, d = e.render, h = "ForwardRef", v = d.displayName || d.name || "", p.displayName || ("" !== v ? h + "(" + v + ")" : h);
      case s:
        return N(e.type);
      case l:
        return N(e._render);
      case u:
        var t = e,
          c = t._payload,
          f = t._init;
        try {
          return N(f(c));
        } catch (e) {
          return null;
        }
    }
    var p, d, h, v;
    return null;
  }
  L.constructor = B, e(L, A.prototype), L.isPureReactComponent = !0;
  var M,
    z,
    U,
    W = Object.prototype.hasOwnProperty,
    V = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function H(e) {
    if (W.call(e, "ref")) {
      var t = Object.getOwnPropertyDescriptor(e, "ref").get;
      if (t && t.isReactWarning) return !1;
    }
    return void 0 !== e.ref;
  }
  function K(e) {
    if (W.call(e, "key")) {
      var t = Object.getOwnPropertyDescriptor(e, "key").get;
      if (t && t.isReactWarning) return !1;
    }
    return void 0 !== e.key;
  }
  function Y(e, t) {
    var r = function () {
      M || (M = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
    };
    r.isReactWarning = !0, Object.defineProperty(e, "key", {
      get: r,
      configurable: !0
    });
  }
  function Q(e, t) {
    var r = function () {
      z || (z = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
    };
    r.isReactWarning = !0, Object.defineProperty(e, "ref", {
      get: r,
      configurable: !0
    });
  }
  function J(e) {
    if ("string" == typeof e.ref && _.current && e.__self && _.current.stateNode !== e.__self) {
      var t = N(_.current.type);
      U[t] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', t, e.ref), U[t] = !0);
    }
  }
  U = {};
  var X = function (e, r, n, o, i, a, s) {
    var u = {
      $$typeof: t,
      type: e,
      key: r,
      ref: n,
      props: s,
      _owner: a,
      _store: {}
    };
    return Object.defineProperty(u._store, "validated", {
      configurable: !1,
      enumerable: !1,
      writable: !0,
      value: !1
    }), Object.defineProperty(u, "_self", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: o
    }), Object.defineProperty(u, "_source", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: i
    }), Object.freeze && (Object.freeze(u.props), Object.freeze(u)), u;
  };
  function G(e, t, r) {
    var n,
      o = {},
      i = null,
      a = null,
      s = null,
      u = null;
    if (null != t) for (n in H(t) && (a = t.ref, J(t)), K(t) && (i = "" + t.key), s = void 0 === t.__self ? null : t.__self, u = void 0 === t.__source ? null : t.__source, t) W.call(t, n) && !V.hasOwnProperty(n) && (o[n] = t[n]);
    var l = arguments.length - 2;
    if (1 === l) o.children = r;else if (l > 1) {
      for (var c = Array(l), f = 0; f < l; f++) c[f] = arguments[f + 2];
      Object.freeze && Object.freeze(c), o.children = c;
    }
    if (e && e.defaultProps) {
      var p = e.defaultProps;
      for (n in p) void 0 === o[n] && (o[n] = p[n]);
    }
    if (i || a) {
      var d = "function" == typeof e ? e.displayName || e.name || "Unknown" : e;
      i && Y(o, d), a && Q(o, d);
    }
    return X(e, i, a, s, u, _.current, o);
  }
  function Z(t, r, n) {
    if (null == t) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + t + ".");
    var o,
      i,
      a = e({}, t.props),
      s = t.key,
      u = t.ref,
      l = t._self,
      c = t._source,
      f = t._owner;
    if (null != r) for (o in H(r) && (u = r.ref, f = _.current), K(r) && (s = "" + r.key), t.type && t.type.defaultProps && (i = t.type.defaultProps), r) W.call(r, o) && !V.hasOwnProperty(o) && (void 0 === r[o] && void 0 !== i ? a[o] = i[o] : a[o] = r[o]);
    var p = arguments.length - 2;
    if (1 === p) a.children = n;else if (p > 1) {
      for (var d = Array(p), h = 0; h < p; h++) d[h] = arguments[h + 2];
      a.children = d;
    }
    return X(t.type, s, u, l, c, f, a);
  }
  function ee(e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }
  var te = !1,
    re = /\/+/g;
  function ne(e) {
    return e.replace(re, "$&/");
  }
  function oe(e, t) {
    return "object" == typeof e && null !== e && null != e.key ? (r = "" + e.key, n = {
      "=": "=0",
      ":": "=2"
    }, "$" + r.replace(/[=:]/g, function (e) {
      return n[e];
    })) : t.toString(36);
    var r, n;
  }
  function ie(e, n, o, i, a) {
    var s = typeof e;
    "undefined" !== s && "boolean" !== s || (e = null);
    var u,
      l,
      c,
      f = !1;
    if (null === e) f = !0;else switch (s) {
      case "string":
      case "number":
        f = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case t:
          case r:
            f = !0;
        }
    }
    if (f) {
      var p = e,
        d = a(p),
        h = "" === i ? "." + oe(p, 0) : i;
      if (Array.isArray(d)) {
        var v = "";
        null != h && (v = ne(h) + "/"), ie(d, n, v, "", function (e) {
          return e;
        });
      } else null != d && (ee(d) && (u = d, l = o + (!d.key || p && p.key === d.key ? "" : ne("" + d.key) + "/") + h, d = X(u.type, l, u.ref, u._self, u._source, u._owner, u.props)), n.push(d));
      return 1;
    }
    var y = 0,
      g = "" === i ? "." : i + ":";
    if (Array.isArray(e)) for (var _ = 0; _ < e.length; _++) y += ie(c = e[_], n, o, g + oe(c, _), a);else {
      var b = m(e);
      if ("function" == typeof b) {
        var C = e;
        b === C.entries && (te || k("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), te = !0);
        for (var R, w = b.call(C), E = 0; !(R = w.next()).done;) y += ie(c = R.value, n, o, g + oe(c, E++), a);
      } else if ("object" === s) {
        var O = "" + e;
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === O ? "object with keys {" + Object.keys(e).join(", ") + "}" : O) + "). If you meant to render a collection of children, use an array instead.");
      }
    }
    return y;
  }
  function ae(e, t, r) {
    if (null == e) return e;
    var n = [],
      o = 0;
    return ie(e, n, "", "", function (e) {
      return t.call(r, e, o++);
    }), n;
  }
  function se(e) {
    if (-1 === e._status) {
      var t = (0, e._result)(),
        r = e;
      r._status = 0, r._result = t, t.then(function (t) {
        if (0 === e._status) {
          var r = t.default;
          void 0 === r && E("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", t);
          var n = e;
          n._status = 1, n._result = r;
        }
      }, function (t) {
        if (0 === e._status) {
          var r = e;
          r._status = 2, r._result = t;
        }
      });
    }
    if (1 === e._status) return e._result;
    throw e._result;
  }
  function ue(e) {
    return "string" == typeof e || "function" == typeof e || e === q.Fragment || e === q.Profiler || e === d || e === q.StrictMode || e === q.Suspense || e === a || e === h || "object" == typeof e && null !== e && (e.$$typeof === u || e.$$typeof === s || e.$$typeof === n || e.$$typeof === o || e.$$typeof === i || e.$$typeof === f || e.$$typeof === l || e[0] === c);
  }
  function le() {
    var e = g.current;
    if (null === e) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    return e;
  }
  var ce,
    fe,
    pe,
    de,
    he,
    ve,
    ye,
    me = 0;
  function ge() {}
  ge.__reactDisabledLog = !0;
  var _e,
    be = w.ReactCurrentDispatcher;
  function Ce(e, t, r) {
    if (void 0 === _e) try {
      throw Error();
    } catch (e) {
      var n = e.stack.trim().match(/\n( *(at )?)/);
      _e = n && n[1] || "";
    }
    return "\n" + _e + e;
  }
  var Re,
    we = !1,
    ke = "function" == typeof WeakMap ? WeakMap : Map;
  function Ee(t, r) {
    if (!t || we) return "";
    var n,
      o = Re.get(t);
    if (void 0 !== o) return o;
    we = !0;
    var i,
      a = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0, i = be.current, be.current = null, function () {
      if (0 === me) {
        ce = console.log, fe = console.info, pe = console.warn, de = console.error, he = console.group, ve = console.groupCollapsed, ye = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: ge,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      me++;
    }();
    try {
      if (r) {
        var s = function () {
          throw Error();
        };
        if (Object.defineProperty(s.prototype, "props", {
          set: function () {
            throw Error();
          }
        }), "object" == typeof Reflect && Reflect.construct) {
          try {
            Reflect.construct(s, []);
          } catch (e) {
            n = e;
          }
          Reflect.construct(t, [], s);
        } else {
          try {
            s.call();
          } catch (e) {
            n = e;
          }
          t.call(s.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (e) {
          n = e;
        }
        t();
      }
    } catch (e) {
      if (e && n && "string" == typeof e.stack) {
        for (var u = e.stack.split("\n"), l = n.stack.split("\n"), c = u.length - 1, f = l.length - 1; c >= 1 && f >= 0 && u[c] !== l[f];) f--;
        for (; c >= 1 && f >= 0; c--, f--) if (u[c] !== l[f]) {
          if (1 !== c || 1 !== f) do {
            if (c--, --f < 0 || u[c] !== l[f]) {
              var p = "\n" + u[c].replace(" at new ", " at ");
              return "function" == typeof t && Re.set(t, p), p;
            }
          } while (c >= 1 && f >= 0);
          break;
        }
      }
    } finally {
      we = !1, be.current = i, function () {
        if (0 == --me) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: e({}, t, {
              value: ce
            }),
            info: e({}, t, {
              value: fe
            }),
            warn: e({}, t, {
              value: pe
            }),
            error: e({}, t, {
              value: de
            }),
            group: e({}, t, {
              value: he
            }),
            groupCollapsed: e({}, t, {
              value: ve
            }),
            groupEnd: e({}, t, {
              value: ye
            })
          });
        }
        me < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }(), Error.prepareStackTrace = a;
    }
    var d = t ? t.displayName || t.name : "",
      h = d ? Ce(d) : "";
    return "function" == typeof t && Re.set(t, h), h;
  }
  function Oe(e, t, r) {
    return Ee(e, !1);
  }
  function Se(e, t, r) {
    if (null == e) return "";
    if ("function" == typeof e) return Ee(e, function (e) {
      var t = e.prototype;
      return !(!t || !t.isReactComponent);
    }(e));
    if ("string" == typeof e) return Ce(e);
    switch (e) {
      case q.Suspense:
        return Ce("Suspense");
      case a:
        return Ce("SuspenseList");
    }
    if ("object" == typeof e) switch (e.$$typeof) {
      case i:
        return Oe(e.render);
      case s:
        return Se(e.type, t, r);
      case l:
        return Oe(e._render);
      case u:
        var n = e,
          o = n._payload,
          c = n._init;
        try {
          return Se(c(o), t, r);
        } catch (e) {}
    }
    return "";
  }
  Re = new ke();
  var je,
    Pe = {},
    xe = w.ReactDebugCurrentFrame;
  function Ae(e) {
    if (e) {
      var t = e._owner,
        r = Se(e.type, e._source, t ? t.type : null);
      xe.setExtraStackFrame(r);
    } else xe.setExtraStackFrame(null);
  }
  function Ie(e) {
    if (e) {
      var t = e._owner;
      R(Se(e.type, e._source, t ? t.type : null));
    } else R(null);
  }
  function Fe() {
    if (_.current) {
      var e = N(_.current.type);
      if (e) return "\n\nCheck the render method of `" + e + "`.";
    }
    return "";
  }
  function De(e) {
    return null != e && void 0 !== (t = e.__source) ? "\n\nCheck your code at " + t.fileName.replace(/^.*[\\\/]/, "") + ":" + t.lineNumber + "." : "";
    var t;
  }
  je = !1;
  var Te = {};
  function Be(e, t) {
    if (e._store && !e._store.validated && null == e.key) {
      e._store.validated = !0;
      var r = function (e) {
        var t = Fe();
        if (!t) {
          var r = "string" == typeof e ? e : e.displayName || e.name;
          r && (t = "\n\nCheck the top-level render call using <" + r + ">.");
        }
        return t;
      }(t);
      if (!Te[r]) {
        Te[r] = !0;
        var n = "";
        e && e._owner && e._owner !== _.current && (n = " It was passed a child from " + N(e._owner.type) + "."), Ie(e), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', r, n), Ie(null);
      }
    }
  }
  function Le(e, t) {
    if ("object" == typeof e) if (Array.isArray(e)) for (var r = 0; r < e.length; r++) {
      var n = e[r];
      ee(n) && Be(n, t);
    } else if (ee(e)) e._store && (e._store.validated = !0);else if (e) {
      var o = m(e);
      if ("function" == typeof o && o !== e.entries) for (var i, a = o.call(e); !(i = a.next()).done;) ee(i.value) && Be(i.value, t);
    }
  }
  function $e(e) {
    var t,
      r = e.type;
    if (null != r && "string" != typeof r) {
      if ("function" == typeof r) t = r.propTypes;else {
        if ("object" != typeof r || r.$$typeof !== i && r.$$typeof !== s) return;
        t = r.propTypes;
      }
      if (t) {
        var n = N(r);
        !function (e, t, r, n, o) {
          var i = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var a in e) if (i(e, a)) {
            var s = void 0;
            try {
              if ("function" != typeof e[a]) {
                var u = Error((n || "React class") + ": " + r + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw u.name = "Invariant Violation", u;
              }
              s = e[a](t, a, n, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (e) {
              s = e;
            }
            !s || s instanceof Error || (Ae(o), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", r, a, typeof s), Ae(null)), s instanceof Error && !(s.message in Pe) && (Pe[s.message] = !0, Ae(o), E("Failed %s type: %s", r, s.message), Ae(null));
          }
        }(t, e.props, "prop", n, e);
      } else void 0 === r.PropTypes || je || (je = !0, E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", N(r) || "Unknown"));
      "function" != typeof r.getDefaultProps || r.getDefaultProps.isReactClassApproved || E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }
  function Ne(e) {
    for (var t = Object.keys(e.props), r = 0; r < t.length; r++) {
      var n = t[r];
      if ("children" !== n && "key" !== n) {
        Ie(e), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), Ie(null);
        break;
      }
    }
    null !== e.ref && (Ie(e), E("Invalid attribute `ref` supplied to `React.Fragment`."), Ie(null));
  }
  function Me(e, r, n) {
    var o = ue(e);
    if (!o) {
      var i = "";
      (void 0 === e || "object" == typeof e && null !== e && 0 === Object.keys(e).length) && (i += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
      var a,
        s = De(r);
      i += s || Fe(), null === e ? a = "null" : Array.isArray(e) ? a = "array" : void 0 !== e && e.$$typeof === t ? (a = "<" + (N(e.type) || "Unknown") + " />", i = " Did you accidentally export a JSX literal instead of a component?") : a = typeof e, E("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", a, i);
    }
    var u = G.apply(this, arguments);
    if (null == u) return u;
    if (o) for (var l = 2; l < arguments.length; l++) Le(arguments[l], e);
    return e === q.Fragment ? Ne(u) : $e(u), u;
  }
  var ze = !1;
  try {
    var Ue = Object.freeze({});
    new Map([[Ue, null]]), new Set([Ue]);
  } catch (e) {}
  var qe = Me,
    We = function (e, t, r) {
      for (var n = Z.apply(this, arguments), o = 2; o < arguments.length; o++) Le(arguments[o], n.type);
      return $e(n), n;
    },
    Ve = function (e) {
      var t = Me.bind(null, e);
      return t.type = e, ze || (ze = !0, k("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(t, "type", {
        enumerable: !1,
        get: function () {
          return k("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
            value: e
          }), e;
        }
      }), t;
    },
    He = {
      map: ae,
      forEach: function (e, t, r) {
        ae(e, function () {
          t.apply(this, arguments);
        }, r);
      },
      count: function (e) {
        var t = 0;
        return ae(e, function () {
          t++;
        }), t;
      },
      toArray: function (e) {
        return ae(e, function (e) {
          return e;
        }) || [];
      },
      only: function (e) {
        if (!ee(e)) throw Error("React.Children.only expected to receive a single React element child.");
        return e;
      }
    };
  q.Children = He, q.Component = A, q.PureComponent = B, q.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = w, q.cloneElement = We, q.createContext = function (e, t) {
    void 0 === t ? t = null : null !== t && "function" != typeof t && E("createContext: Expected the optional second argument to be a function. Instead received: %s", t);
    var r = {
      $$typeof: o,
      _calculateChangedBits: t,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    };
    r.Provider = {
      $$typeof: n,
      _context: r
    };
    var i = !1,
      a = !1,
      s = !1,
      u = {
        $$typeof: o,
        _context: r,
        _calculateChangedBits: r._calculateChangedBits
      };
    return Object.defineProperties(u, {
      Provider: {
        get: function () {
          return a || (a = !0, E("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), r.Provider;
        },
        set: function (e) {
          r.Provider = e;
        }
      },
      _currentValue: {
        get: function () {
          return r._currentValue;
        },
        set: function (e) {
          r._currentValue = e;
        }
      },
      _currentValue2: {
        get: function () {
          return r._currentValue2;
        },
        set: function (e) {
          r._currentValue2 = e;
        }
      },
      _threadCount: {
        get: function () {
          return r._threadCount;
        },
        set: function (e) {
          r._threadCount = e;
        }
      },
      Consumer: {
        get: function () {
          return i || (i = !0, E("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), r.Consumer;
        }
      },
      displayName: {
        get: function () {
          return r.displayName;
        },
        set: function (e) {
          s || (k("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", e), s = !0);
        }
      }
    }), r.Consumer = u, r._currentRenderer = null, r._currentRenderer2 = null, r;
  }, q.createElement = qe, q.createFactory = Ve, q.createRef = function () {
    var e = {
      current: null
    };
    return Object.seal(e), e;
  }, q.forwardRef = function (e) {
    null != e && e.$$typeof === s ? E("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" != typeof e ? E("forwardRef requires a render function but was given %s.", null === e ? "null" : typeof e) : 0 !== e.length && 2 !== e.length && E("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === e.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), null != e && (null == e.defaultProps && null == e.propTypes || E("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"));
    var t,
      r = {
        $$typeof: i,
        render: e
      };
    return Object.defineProperty(r, "displayName", {
      enumerable: !1,
      configurable: !0,
      get: function () {
        return t;
      },
      set: function (r) {
        t = r, null == e.displayName && (e.displayName = r);
      }
    }), r;
  }, q.isValidElement = ee, q.lazy = function (e) {
    var t,
      r,
      n = {
        $$typeof: u,
        _payload: {
          _status: -1,
          _result: e
        },
        _init: se
      };
    return Object.defineProperties(n, {
      defaultProps: {
        configurable: !0,
        get: function () {
          return t;
        },
        set: function (e) {
          E("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), t = e, Object.defineProperty(n, "defaultProps", {
            enumerable: !0
          });
        }
      },
      propTypes: {
        configurable: !0,
        get: function () {
          return r;
        },
        set: function (e) {
          E("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), r = e, Object.defineProperty(n, "propTypes", {
            enumerable: !0
          });
        }
      }
    }), n;
  }, q.memo = function (e, t) {
    ue(e) || E("memo: The first argument must be a component. Instead received: %s", null === e ? "null" : typeof e);
    var r,
      n = {
        $$typeof: s,
        type: e,
        compare: void 0 === t ? null : t
      };
    return Object.defineProperty(n, "displayName", {
      enumerable: !1,
      configurable: !0,
      get: function () {
        return r;
      },
      set: function (t) {
        r = t, null == e.displayName && (e.displayName = t);
      }
    }), n;
  }, q.useCallback = function (e, t) {
    return le().useCallback(e, t);
  }, q.useContext = function (e, t) {
    var r = le();
    if (void 0 !== t && E("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", t, "number" == typeof t && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks" : ""), void 0 !== e._context) {
      var n = e._context;
      n.Consumer === e ? E("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : n.Provider === e && E("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
    }
    return r.useContext(e, t);
  }, q.useDebugValue = function (e, t) {
    return le().useDebugValue(e, t);
  }, q.useEffect = function (e, t) {
    return le().useEffect(e, t);
  }, q.useImperativeHandle = function (e, t, r) {
    return le().useImperativeHandle(e, t, r);
  }, q.useLayoutEffect = function (e, t) {
    return le().useLayoutEffect(e, t);
  }, q.useMemo = function (e, t) {
    return le().useMemo(e, t);
  }, q.useReducer = function (e, t, r) {
    return le().useReducer(e, t, r);
  }, q.useRef = function (e) {
    return le().useRef(e);
  }, q.useState = function (e) {
    return le().useState(e);
  }, q.version = "17.0.2";
}(), "production" === process.env.NODE_ENV ? a.exports = s : a.exports = W;
var V = a.exports;
function H(e) {
  var t = 1024,
    r = 1048576,
    n = 1073741824;
  if (e < r) {
    var o = Number((e / t).toFixed(0));
    return o <= 0 ? e + " B" : o + " KB";
  }
  return e < n ? (e / r).toFixed(0) + " MB" : e < 1099511627776 ? (e / n).toFixed(0) + " GB" : "";
}
function K(e, t) {
  var r = !1;
  "#" == e[0] && (e = e.slice(1), r = !0);
  var n = parseInt(e, 16),
    o = (n >> 16) + t;
  o > 255 ? o = 255 : o < 0 && (o = 0);
  var i = (n >> 8 & 255) + t;
  i > 255 ? i = 255 : i < 0 && (i = 0);
  var a = (255 & n) + t;
  return a > 255 ? a = 255 : a < 0 && (a = 0), (r ? "#" : "") + (a | i << 8 | o << 16).toString(16);
}
function Y(e) {
  return V.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "23",
    viewBox: "0 0 512 512"
  }, V.createElement("path", {
    fill: e.color,
    d: "M504.1 256C504.1 119 393 7.9 256 7.9S7.9 119 7.9 256 119 504.1 256 504.1 504.1 393 504.1 256z"
  }), V.createElement("path", {
    fill: "#FFF",
    d: "M285 256l72.5-84.2c7.9-9.2 6.9-23-2.3-31-9.2-7.9-23-6.9-30.9 2.3L256 222.4l-68.2-79.2c-7.9-9.2-21.8-10.2-31-2.3-9.2 7.9-10.2 21.8-2.3 31L227 256l-72.5 84.2c-7.9 9.2-6.9 23 2.3 31 4.1 3.6 9.2 5.3 14.3 5.3 6.2 0 12.3-2.6 16.6-7.6l68.2-79.2 68.2 79.2c4.3 5 10.5 7.6 16.6 7.6 5.1 0 10.2-1.7 14.3-5.3 9.2-7.9 10.2-21.8 2.3-31L285 256z"
  }));
}
var Q = {
    progressBar: {
      borderRadius: 3,
      boxShadow: "inset 0 1px 3px rgba(0, 0, 0, .2)",
      bottom: 14,
      position: "absolute",
      width: "80%"
    },
    buttonProgressBar: {
      position: "inherit",
      width: "100%"
    },
    progressBarFill: {
      backgroundColor: "#659cef",
      borderRadius: 3,
      height: 10,
      transition: "width 500ms ease-in-out"
    }
  },
  J = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return o(t, e), t.prototype.render = function () {
      var e = this.props,
        t = e.style,
        r = e.progressBar,
        n = e.displayProgressBarStatus,
        o = e.isButtonProgressBar;
      return V.createElement("div", {
        style: Object.assign({}, Q.progressBar, o && Q.buttonProgressBar)
      }, V.createElement("span", {
        style: Object.assign({}, Q.progressBarFill, t, {
          width: r + "%",
          display: n
        })
      }));
    }, t;
  }(V.Component),
  X = {
    dropArea: {
      alignItems: "center",
      borderStyle: "dashed",
      borderWidth: 2,
      borderRadius: 20,
      borderColor: "#CCC",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      padding: 20
    },
    dropAreaDefaultBorderColor: {
      borderColor: "#CCC"
    },
    inputFile: {
      display: "none"
    },
    highlight: {
      borderColor: "#686868"
    },
    unhighlight: {
      borderColor: "#CCC"
    },
    dropFile: {
      background: "linear-gradient(to bottom, #EEE, #DDD)",
      borderRadius: 20,
      display: "block",
      height: 120,
      width: 100,
      paddingLeft: 10,
      paddingRight: 10,
      position: "relative",
      zIndex: 10
    },
    column: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    },
    fileSizeInfo: {
      backgroundColor: "rgba(255, 255, 255, 0.4)",
      borderRadius: 3,
      lineHeight: 1,
      marginBottom: "0.5em",
      padding: "0 0.4em"
    },
    fileNameInfo: {
      backgroundColor: "rgba(255, 255, 255, 0.4)",
      borderRadius: 3,
      fontSize: 14,
      lineHeight: 1,
      padding: "0 0.4em"
    },
    defaultCursor: {
      cursor: "default"
    },
    pointerCursor: {
      cursor: "pointer"
    },
    dropFileRemoveButton: {
      height: 23,
      position: "absolute",
      right: 6,
      top: 6,
      width: 23
    }
  },
  G = function (e) {
    function t() {
      var t,
        n,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p = e.apply(this, arguments) || this;
      return p.inputFileRef = V.createRef(), p.dropAreaRef = V.createRef(), p.fileSizeInfoRef = V.createRef(), p.fileNameInfoRef = V.createRef(), p.REMOVE_ICON_COLOR = p.props.removeButtonColor || (null === (a = null === (o = null === (n = null === (t = p.props.style) || void 0 === t ? void 0 : t.dropArea) || void 0 === n ? void 0 : n.dropFile) || void 0 === o ? void 0 : o.removeButton) || void 0 === a ? void 0 : a.color) || (null === (l = null === (u = null === (s = p.props.style) || void 0 === s ? void 0 : s.dropFile) || void 0 === u ? void 0 : u.removeButton) || void 0 === l ? void 0 : l.color) || (null === (f = null === (c = p.props.style) || void 0 === c ? void 0 : c.removeButton) || void 0 === f ? void 0 : f.color) || "#A01919", p.REMOVE_ICON_COLOR_LIGHT = K(p.REMOVE_ICON_COLOR, 40), p.state = {
        dropAreaCustom: {},
        progressBar: 0,
        displayProgressBarStatus: "none",
        file: null,
        timeout: null,
        files: null,
        removeIconColor: p.REMOVE_ICON_COLOR,
        isCanceled: !1
      }, p.componentDidUpdate = function (e) {
        p.props.isReset !== e.isReset && p.removeFile();
      }, p.componentDidMount = function () {
        var e = p.dropAreaRef.current;
        if (e) {
          if (["dragenter", "dragover", "dragleave", "drop"].forEach(function (t) {
            e.addEventListener(t, p.preventDefaults, !1);
          }), !p.props.noDrag) {
            ["dragenter", "dragover"].forEach(function (t) {
              e.addEventListener(t, p.highlight, !1);
            }), e.addEventListener("dragleave", p.unhighlight, !1), e.addEventListener("drop", p.unhighlight, !1), e.addEventListener("drop", p.visibleProgressBar, !1), e.addEventListener("drop", p.handleDrop, !1);
          }
        }
      }, p.componentWillUnmount = function () {
        var e = p.dropAreaRef.current;
        if (["dragenter", "dragover", "dragleave", "drop"].forEach(function (t) {
          e.removeEventListener(t, p.preventDefaults, !1);
        }), !p.props.noDrag) {
          ["dragenter", "dragover"].forEach(function (t) {
            e.removeEventListener(t, p.highlight, !1);
          }), e.removeEventListener("dragleave", p.unhighlight, !1), e.removeEventListener("drop", p.unhighlight, !1), e.removeEventListener("drop", p.visibleProgressBar, !1), e.removeEventListener("drop", p.handleDrop, !1);
        }
      }, p.preventDefaults = function (e) {
        e.preventDefault(), e.stopPropagation();
      }, p.highlight = function () {
        var e,
          t,
          r,
          n,
          o = p.props.style;
        p.setState({
          dropAreaCustom: Object.assign({}, (null == o ? void 0 : o.dropAreaActive) ? (null == o ? void 0 : o.dropAreaActive.borderColor) ? null == o ? void 0 : o.dropAreaActive : Object.assign({}, null == o ? void 0 : o.dropAreaActive, X.highlight) : (null === (e = null == o ? void 0 : o.dropArea) || void 0 === e ? void 0 : e.dropAreaActive) ? (null === (t = null == o ? void 0 : o.dropArea) || void 0 === t ? void 0 : t.dropAreaActive.borderColor) ? null === (r = null == o ? void 0 : o.dropArea) || void 0 === r ? void 0 : r.dropAreaActive : Object.assign({}, null === (n = null == o ? void 0 : o.dropArea) || void 0 === n ? void 0 : n.dropAreaActive, X.highlight) : X.highlight)
        }), p.setState({
          progressBar: 0
        });
      }, p.unhighlight = function () {
        var e, t;
        p.setState({
          dropAreaCustom: Object.assign({}, (null === (t = null === (e = p.props.style) || void 0 === e ? void 0 : e.dropArea) || void 0 === t ? void 0 : t.borderColor) ? {} : X.dropAreaDefaultBorderColor)
        });
      }, p.visibleProgressBar = function () {
        p.props.noProgressBar || p.setState({
          displayProgressBarStatus: "block"
        });
      }, p.handleDrop = function (e) {
        var t = null,
          r = !1;
        void 0 === e.files ? t = e.dataTransfer.files : t = e.files;
        0 === t.length && (t = p.state.files, r = !0), p.setState({
          files: t,
          isCanceled: r
        }, function () {
          p.handleFiles();
        });
      }, p.handleFiles = function () {
        p.setState({
          progressBar: 0
        });
        i([], p.state.files).forEach(p.uploadFile);
      }, p.uploadFile = function (e) {
        p.displayFileInfo(e), p.setState({
          file: e
        });
        var t = p.props,
          n = t.onDrop,
          o = t.onFileLoad,
          i = t.onError,
          a = t.config,
          s = void 0 === a ? {} : a,
          u = new window.FileReader(),
          l = {},
          c = e.size,
          f = [],
          d = 0;
        if (n || o) {
          var h = p;
          l = Object.assign({
            complete: (null == s ? void 0 : s.complete) || (null == s ? void 0 : s.step) ? s.complete : function () {
              !n && o ? o(f, e) : n && !o && n(f, e);
            },
            step: (null == s ? void 0 : s.step) ? s.step : function (t) {
              if (f.push(t), s && s.preview) d = Math.round(f.length / s.preview * 100), h.setState({
                progressBar: d
              }), f.length === s.preview && (!n && o ? o(f, e) : n && !o && n(f, e));else {
                var r = t.meta.cursor,
                  i = Math.round(r / c * 100);
                if (i === d) return;
                d = i;
              }
              h.setState({
                progressBar: d
              });
            }
          }, l);
        }
        i && (l = Object.assign({
          error: i
        }, l)), s && (l = Object.assign({}, s, l)), u.onload = function (e) {
          r.parse(e.target.result, l);
        }, u.onloadend = function () {
          clearTimeout(p.state.timeout), p.setState({
            timeout: setTimeout(function () {
              p.disableProgressBar();
            }, 2e3)
          });
        }, u.readAsText(e, s.encoding || "utf-8");
      }, p.displayFileInfo = function (e) {
        p.childrenIsFunction() || (p.fileSizeInfoRef.current.innerHTML = H(e.size), p.fileNameInfoRef.current.innerHTML = e.name);
      }, p.disableProgressBar = function () {
        p.props.noProgressBar || p.setState({
          displayProgressBarStatus: "none"
        });
      }, p.childrenIsFunction = function () {
        return "function" == typeof p.props.children;
      }, p.fileChange = function (e) {
        var t = e.target;
        p.props.noProgressBar ? p.handleDrop(t) : p.setState({
          displayProgressBarStatus: "block"
        }, function () {
          p.handleDrop(t);
        });
      }, p.open = function (e) {
        var t = p.state.displayProgressBarStatus;
        e && "none" === t && (p.preventDefaults(e), p.inputFileRef.current.value = null, p.inputFileRef.current.click());
      }, p.renderChildren = function () {
        var e = p.props.children,
          t = p.state,
          r = t.file,
          n = t.progressBar;
        return p.childrenIsFunction() ? e({
          file: r,
          progressBar: n
        }) : e;
      }, p.handleRemoveFile = function (e) {
        e && (e.stopPropagation(), p.removeFile());
      }, p.removeFile = function () {
        p.setState({
          files: null,
          file: null
        });
        var e = p.props.onRemoveFile;
        e && e(null), p.inputFileRef.current.value = null;
      }, p.changeRemoveIconColor = function (e) {
        e && p.setState({
          removeIconColor: e
        });
      }, p.renderDropFileRemoveButton = function () {
        var e = p.props.addRemoveButton,
          t = p.state,
          r = t.removeIconColor,
          n = t.displayProgressBarStatus;
        return e && "none" === n ? V.createElement("div", {
          style: X.dropFileRemoveButton,
          onClick: function (e) {
            return p.handleRemoveFile(e);
          },
          onMouseOver: function () {
            return p.changeRemoveIconColor(p.REMOVE_ICON_COLOR_LIGHT);
          },
          onMouseOut: function () {
            return p.changeRemoveIconColor(p.REMOVE_ICON_COLOR);
          }
        }, V.createElement(Y, {
          color: r
        })) : e ? V.createElement("div", {
          style: X.dropFileRemoveButton
        }, V.createElement(Y, {
          color: p.REMOVE_ICON_COLOR
        })) : null;
      }, p;
    }
    return o(t, e), t.prototype.render = function () {
      var e,
        t,
        r,
        n,
        o,
        i,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d = this,
        h = this.props,
        v = h.style,
        y = h.noClick,
        m = h.children,
        g = h.noProgressBar,
        _ = h.progressBarColor,
        b = h.accept,
        C = this.state,
        R = C.dropAreaCustom,
        w = C.files,
        k = C.isCanceled,
        E = C.progressBar,
        O = C.displayProgressBarStatus;
      return V.createElement(V.Fragment, null, V.createElement("input", {
        type: "file",
        accept: b || "text/csv, .csv, application/vnd.ms-excel",
        ref: this.inputFileRef,
        style: X.inputFile,
        onChange: function (e) {
          return d.fileChange(e);
        }
      }), this.childrenIsFunction() ? V.createElement("div", {
        ref: this.dropAreaRef
      }, this.renderChildren(), w && w.length > 0 && !k && !g && V.createElement(J, {
        style: Object.assign({}, _ ? {
          backgroundColor: _
        } : {}, (null === (f = null === (c = null == v ? void 0 : v.dropArea) || void 0 === c ? void 0 : c.dropFile) || void 0 === f ? void 0 : f.progressBar) || (null === (p = null == v ? void 0 : v.dropFile) || void 0 === p ? void 0 : p.progressBar) || (null == v ? void 0 : v.progressBar)),
        progressBar: E,
        displayProgressBarStatus: O,
        isButtonProgressBar: !0
      })) : V.createElement("div", {
        ref: this.dropAreaRef,
        style: Object.assign({}, X.dropArea, null == v ? void 0 : v.dropArea, R, void 0 !== y || "block" === O ? X.defaultCursor : X.pointerCursor),
        onClick: function (e) {
          y || d.open(e);
        }
      }, w && w.length > 0 ? V.createElement("div", {
        style: Object.assign({}, X.dropFile, X.column, (null === (e = null == v ? void 0 : v.dropArea) || void 0 === e ? void 0 : e.dropFile) || (null == v ? void 0 : v.dropFile))
      }, this.renderDropFileRemoveButton(), V.createElement("div", {
        style: X.column
      }, V.createElement("span", {
        style: Object.assign({}, X.fileSizeInfo, (null === (r = null === (t = null == v ? void 0 : v.dropArea) || void 0 === t ? void 0 : t.dropFile) || void 0 === r ? void 0 : r.fileSizeInfo) || (null === (n = null == v ? void 0 : v.dropArea) || void 0 === n ? void 0 : n.fileSizeInfo) || (null == v ? void 0 : v.fileSizeInfo)),
        ref: this.fileSizeInfoRef
      }), V.createElement("span", {
        style: Object.assign({}, X.fileNameInfo, (null === (i = null === (o = null == v ? void 0 : v.dropArea) || void 0 === o ? void 0 : o.dropFile) || void 0 === i ? void 0 : i.fileNameInfo) || (null === (a = null == v ? void 0 : v.dropFile) || void 0 === a ? void 0 : a.fileNameInfo) || (null == v ? void 0 : v.fileNameInfo)),
        ref: this.fileNameInfoRef
      })), w && w.length > 0 && !k && !g && V.createElement(J, {
        style: Object.assign({}, _ ? {
          backgroundColor: _
        } : {}, (null === (u = null === (s = null == v ? void 0 : v.dropArea) || void 0 === s ? void 0 : s.dropFile) || void 0 === u ? void 0 : u.progressBar) || (null === (l = null == v ? void 0 : v.dropFile) || void 0 === l ? void 0 : l.progressBar) || (null == v ? void 0 : v.progressBar)),
        progressBar: E,
        displayProgressBarStatus: O
      })) : m));
    }, t.defaultProps = {
      isReset: !1
    }, t;
  }(V.Component),
  Z = "link",
  ee = "button",
  te = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.download = function (e, t, n, o) {
        var i = n ? "\ufeff" : "",
          a = null,
          s = null;
        "function" == typeof e && (e = e()), a = "object" == typeof e ? r.unparse(e, o) : e;
        var u = new Blob(["" + i + a], {
            type: "text/csv;charset=utf-8;"
          }),
          l = window.navigator;
        s = l.msSaveBlob ? l.msSaveBlob(u, t + ".csv") : window.URL.createObjectURL(u);
        var c = document.createElement("a");
        c.href = s, c.setAttribute("download", t + ".csv"), c.click(), c.remove();
      }, t;
    }
    return o(t, e), t.prototype.render = function () {
      var e = this,
        t = this.props,
        r = t.children,
        n = t.data,
        o = t.filename,
        i = t.type,
        a = t.className,
        s = t.style,
        u = t.bom,
        l = void 0 !== u && u,
        c = t.config,
        f = void 0 === c ? {} : c;
      return "link" === i ? V.createElement("a", {
        onClick: function () {
          return e.download(n, o, l, f);
        },
        className: a,
        style: s
      }, r) : V.createElement("button", {
        onClick: function () {
          return e.download(n, o, l, f);
        },
        className: a,
        style: s
      }, r);
    }, t.defaultProps = {
      type: "link"
    }, t;
  }(V.Component);
function re(e, t) {
  return void 0 === t && (t = {}), r.parse(e, t);
}
function ne(e, t) {
  void 0 === t && (t = {}), r.parse(e, Object.assign({}, {
    download: !0
  }, t));
}
function oe(e, t) {
  return void 0 === t && (t = {}), r.unparse(e, t);
}
var ie = r.BAD_DELIMITERS,
  ae = r.RECORD_SEP,
  se = r.UNIT_SEP,
  ue = r.WORKERS_SUPPORTED,
  le = r.LocalChunkSize,
  ce = r.DefaultDelimiter;
export { ie as BAD_DELIMITERS, ee as BUTTON_TYPE, te as CSVDownloader, G as CSVReader, ce as DefaultDelimiter, Z as LINK_TYPE, le as LocalChunkSize, ae as RECORD_SEP, se as UNIT_SEP, ue as WORKERS_SUPPORTED, oe as jsonToCSV, ne as readRemoteFile, re as readString };